<template>
  <div>
    <notification-template
      :large="large"
      :hash="notification.id"
      :urlProfilePhoto="student.urlProfilePhoto"
    >
      <template v-slot:header>
        {{$t('notifications.student')}}
        {{$t('notifications.newLessonTime')}}
      </template>
      <router-link :to="`/students/${student.slug}`" class="font-medium">
        {{student.name}}
      </router-link>
      {{$t('notifications.studentAccepted')}}
      <template v-slot:actions>
          <p>
            <span class="px-2 py-1 font-medium uppercase bg-green-400 text-white rounded-lg
              mr-2">
              {{$t('notifications.newTime')}}:
            </span>
              {{formattedNewSlotStartDate}}
          </p>
          <button class="flex w-auto justify-center items-center text-orange-academy-300
            uppercase px-2 py-1 rounded-sm border-orange-academy-300
            border opacity-60 hover:opacity-100"
            @click="goToCalendar"
          >
            <span class="pr-2 uppercase">
              {{$t('notifications.calendar')}}
            </span>
            <calendar-icon></calendar-icon>
          </button>
      </template>
    </notification-template>
  </div>
</template>

<script>
import NotificationTemplate from './NotificationTemplate.vue';
import NotificationsMixin from '../../mixins/NotificationsMixin';
import CalendarIcon from '../graphics/CalendarIcon.vue';

export default {
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      new_slot: { ...this.notification.data.new_slot },
      student: { ...this.notification.data.student },
    };
  },
  mixins: [NotificationsMixin],
  components: {
    NotificationTemplate,
    CalendarIcon,
  },
  methods: {
    goToCalendar() {
      this.$router.push({ name: 'teacher calendar' });
    },
  },

};
</script>
